import Message from "messaging/message";

export enum CreateMessageParam {
  contentPlainText = "contentPlainText",
  subject = "subject",
  attachments = "attachments",
  isAutoGenerated = "isAutoGenerated",
  publish = "publish"
}

export default class CreateMessageAPIRequest {
  public formData: FormData;

  public constructor(message: Message) {
    this.formData = new FormData();
    if (message.content) {
      this.formData.append(
        CreateMessageParam.contentPlainText,
        message.content
      );
    } else if (message.attachments.length === 0) {
      throw new Error("Message content is required when no attachments are provided.");
    }
    this.formData.append(
      CreateMessageParam.subject,
      message.subject?.toString() ?? ""
    );
    this.formData.append(
      CreateMessageParam.isAutoGenerated,
      message.isAutoGenerated?.toString() ?? "false"
    );
    this.formData.append(
      CreateMessageParam.publish,
      message.isMarkedForPublish?.toString() ?? "false"
    )

    for (const attachment of message.attachments) {
      if (attachment.rawData === undefined) continue;
      this.formData.append(
        CreateMessageParam.attachments,
        attachment.rawData,
        attachment.name
      );
    }
  }
}
